import { Controller, type Control, type UseFormWatch } from "react-hook-form";
import { ProgramScheduleType } from "../../../../types/dto/program";
import { Input } from "../../../../shared/components/ui/form/inputs";
import moment from "moment";
import { Select } from "antd";
import {
  PAYMENT_CONCEPTS,
  isCosmetologyProgramName,
  resolvePaymentConcept,
} from "../../../../shared/utils/academyPaymentConcepts";
import { ProgramPaymentType } from "../../../../types/dto/program";

type EditPaymentFormValues = {
  amount: string;
  payment_date: string;
  payment_concept: string;
  program_payment_schedule_id?: string | null;
};

export default function EditProgramPaymentForm({
  control,
  payment,
  programScheduleByProgram,
  watch,
}: {
  control: Control<EditPaymentFormValues>;
  payment: ProgramPaymentType;
  programScheduleByProgram: ProgramScheduleType[];
  watch: UseFormWatch<EditPaymentFormValues>;
}) {
  const paymentConcept = watch("payment_concept") || PAYMENT_CONCEPTS.CUOTA;
  const isCuota = paymentConcept === PAYMENT_CONCEPTS.CUOTA;
  const showInternshipOption = isCosmetologyProgramName(payment.program?.name);
  const currentConcept = resolvePaymentConcept(payment.payment_concept);

  const conceptOptions = [
    {
      value: PAYMENT_CONCEPTS.CUOTA,
      label: "Cuota mensual",
    },
    {
      value: PAYMENT_CONCEPTS.EXTRA_HOURS,
      label: "Horas adicionales",
    },
    ...(showInternshipOption
      ? [
          {
            value: PAYMENT_CONCEPTS.INTERNSHIP,
            label: "Pasantías",
          },
        ]
      : []),
  ];

  return (
    <div className="flex flex-col gap-3">
      <Controller
        control={control}
        name="payment_concept"
        render={({ field, fieldState }) => (
          <div>
            <label>Concepto de pago</label>
            <Select
              {...field}
              style={{ width: "100%" }}
              placeholder="Selecciona el concepto"
              options={conceptOptions}
              disabled={currentConcept === PAYMENT_CONCEPTS.INTERNSHIP && !showInternshipOption}
            />
            {fieldState.error ? (
              <span className="mt-1 block text-xs text-red-500">
                {fieldState.error.message}
              </span>
            ) : null}
          </div>
        )}
      />

      {isCuota ? (
        <Controller
          control={control}
          name="program_payment_schedule_id"
          render={({ field, fieldState }) => (
            <div>
              <label>Periodo de la cuota</label>
              <Select
                {...field}
                showSearch
                style={{ width: "100%" }}
                placeholder="Selecciona el periodo"
                optionFilterProp="label"
                options={
                  programScheduleByProgram?.length > 0
                    ? programScheduleByProgram.map((it) => ({
                        key: `${it.id}`,
                        value: `${it.id}`,
                        label: `${moment(it.month).format("YYYY / MMM")}`,
                      }))
                    : [
                        {
                          key: "",
                          value: "",
                          label: "No hay cuotas disponibles",
                        },
                      ]
                }
              />
              {fieldState.error ? (
                <span className="mt-1 block text-xs text-red-500">
                  {fieldState.error.message}
                </span>
              ) : null}
            </div>
          )}
        />
      ) : null}

      <Input
        style={{ background: "none" }}
        control={control}
        label="Monto"
        name="amount"
        placeholder="100000"
        type="number"
      />
      <Input
        style={{ background: "none" }}
        control={control}
        label="Fecha de pago"
        name="payment_date"
        placeholder=""
        type="date"
      />
    </div>
  );
}
